"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapEditorialCarousel = void 0;
var _editorialFetching = require("@ori/editorial-fetching");
/**
 * Utility to filter carousel slides with thruthy data and map them to `ArticleBoxProps` type.
 * @returns Slides with thruthy data mapped to `ArticleBoxProps` type.
 */
const mapEditorialCarousel = ({
  slides
}) => (slides ?? []).filter(slide => !!slide).filter(({
  editorialLink: {
    relativeUrl
  },
  description,
  thumbnailUrl,
  title
}) => !!relativeUrl && !!description && !!thumbnailUrl && !!title).map(({
  editorialLink: {
    relativeUrl
  },
  description,
  themeTag,
  thumbnailUrl,
  title
}) => ({
  categoryTitle: themeTag,
  image: {
    alt: title,
    url: thumbnailUrl
  },
  introText: description,
  isVideoArticle: false,
  link: {
    relativeUrl,
    type: _editorialFetching.LinkType.EditorialArticle
  },
  title
}));
exports.mapEditorialCarousel = mapEditorialCarousel;
